<template>
  <div class="content">
    <div class="content-main">
      <p class="content-title">VIP服务页面Banner</p>
      <div class="content-input">
        <div class="content-input-item">
          <label>状态：</label>
          <el-select v-model="state" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in stateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>展示页面：</label>
          <el-select v-model="showPage" placeholder="Select" style="width: 8em">
            <el-option v-for="item in showPageArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <ElButtons type="primary" icon="search" v-loading="searchLoading" :disable="searchLoading" @click="getPage(true)"> 查询 </ElButtons>
          <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>
        </div>
      </div>
    </div>
    <div class="content-main">
      <div class="content-button">
        <div>
          <el-button type="primary" @click="editBannerDialog(-1)">创建</el-button>
        </div>
        <BtnGroup :tableRef="$refs.multipleTableRef" :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>
      </div>
      <div class="content-table">
        <el-table
            ref="multipleTableRef"
            :data="pageDataList"
            style="width: 100%"
            v-loading="listLoading"
            @cell-click="toggleSelection"
            border
        >
          <el-table-column type="index" label="序号" v-if="checkColList.indexOf('序号') > -1" width="60"></el-table-column>
          <el-table-column property="createTime" label="创建时间" v-if="checkColList.indexOf('创建时间') > -1" ></el-table-column>
          <el-table-column property="" label="banner图片" v-if="checkColList.indexOf('banner图片') > -1" class-name="cursor">
            <template #default="scope">
              <el-image style="height: 80px" :src="scope.row.picture"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
            </template>
          </el-table-column>
          <el-table-column property="name" label="标题" v-if="checkColList.indexOf('标题') > -1"></el-table-column>
          <el-table-column property="" label="展示页面" v-if="checkColList.indexOf('展示页面') > -1">
            <template #default="scope">
              {{scope.row.showPage == 1?'我的账户页面':scope.row.showPage == 2?'vip服务页面':scope.row.showPage == 3?'svip服务页面':''}}
            </template>
          </el-table-column>
          <el-table-column property="" label="类型信息" v-if="checkColList.indexOf('类型信息') > -1">
            <template #default="scope">
              <p style="color:blue;">跳转：{{scope.row.jumpType == 1 ? '不跳转' : scope.row.jumpType == 2 ? '内部浏览器' : scope.row.jumpType == 3 ? '外部浏览器' : '未知'}}</p>
<!--              <p style="color:red;">平台：{{scope.row.showPlatform == -1 ? '客户端' : scope.row.showPlatform == 1 ? 'Android' : scope.row.showPlatform == 2 ? 'IOS' : scope.row.showPlatform == 3 ? 'Web' : ''}}</p>-->
            </template>
          </el-table-column>
          <el-table-column property="url" label="url" v-if="checkColList.indexOf('url') > -1"></el-table-column>
          <el-table-column property="showUid" label="展示用户" v-if="checkColList.indexOf('展示用户') > -1"></el-table-column>
          <el-table-column property="showOrder" label="排序" v-if="checkColList.indexOf('排序') > -1"></el-table-column>
          <el-table-column property="" label="状态" v-if="checkColList.indexOf('状态') > -1">
            <template #default="scope">
              <p>{{scope.row.state == 1 ? '待展示' : scope.row.state == 2 ? '展示中' : scope.row.state == 3 ? '已下架' : ''}}</p>
              <p>新人状态：{{scope.row.newuserShow == 0 ? '不限' : scope.row.newuserShow == 1 ? '新用户展示' : scope.row.newuserShow == 2 ? '非新用户展示' : ''}}</p>
              <p>VIP状态：{{scope.row.vipShow == 0 ? '不限' : scope.row.vipShow == 1 ? '已开通过会员' : scope.row.vipShow == 2 ? '未开通过会员' : ''}}</p>
            </template>
          </el-table-column>
          <el-table-column property="" label="操作" v-if="checkColList.indexOf('操作') > -1">
            <template #default="scope">
              <el-space wrap>
                <el-button size="small" @click="editBannerDialog(scope.$index,scope.row)" type="primary">编辑</el-button>
                <el-button size="small" v-loading="scope.row['updateLoading']" type="success" v-show="scope.row.state == 1 || scope.row.state == 3" @click="updateState(scope.$index, scope.row, 2)">上架</el-button>
                <el-button size="small" v-loading="scope.row['updateLoading']" type="warning" v-show="scope.row.state == 2" @click="updateState(scope.$index, scope.row, 3)">下架</el-button>
              </el-space>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import BtnGroup from '../../components/BtnGroup'
import { getVipBannerPageList, updateVipBannerState } from '../../api/url'
import {getFormData, postFormData} from '../../api/api'
import Dialog from "@/assets/js/dialog";
import vipBannerDialog from "./components/vipBannerDialog";
import ImgUpload from "./components/ImgUpload";

export default {
  name: "BannerVip",
  components: { BtnGroup },
  data() {
    return {

      sexArray: [
        {label: '不限', value: -1},
        {label: '男', value: 1},
        {label: '女', value: 2},
      ],
      sex: -1,

      showPageArray: [
        {label: '不限', value: -1},
        {label: '我的账户页面', value: 1},
        {label: 'VIP服务页面', value: 2},
        {label: 'SVIP服务页面', value: 3},
      ],
      showPage: -1,

      stateArray: [
        {label: '不限', value: -1},
        {label: '待展示', value: 1},
        {label: '展示中', value: 2},
        {label: '已下架', value: 3},
      ],
      state: 2,

      //刷新组
      colList: ['序号', '创建时间', 'banner图片', '标题', '展示页面', '类型信息', 'url', '展示用户','排序','状态','操作'],
      checkColList: [],

      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,

      searchLoading: false,
      listLoading: false,

    }
  },
  methods: {
    getSearchType(e) {
      this.searchType = e;
      // console.log(e)
    },
    getSearchValue(e) {
      this.searchValue = e;
      // console.log(e)
    },
    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },
    // 重置参数
    refreshParam() {
      this.showPage = -1;
      this.state = 2;
      this.getPage(true);
    },
    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['showPage'] = this.showPage;
      param['state'] = this.state;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getVipBannerPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch(() => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    editBannerDialog(idx, row) {
      let _title = '';
      let vipForm = {}
      if (idx > -1) {
        _title = '编辑banner'
        vipForm = Object.assign({}, row);
      }else {
        _title = '创建banner'
      }
      Dialog.open({
        title: _title,
        component: vipBannerDialog,
        data: {
          vipForm: vipForm,
          ids: idx,
          width: '1040px'
        },
        confirm: (result) => {
            this.getPage()
        }
      })
    },

    toggleSelection(row, column, cell, event) {

      if(column.label == 'banner图片') {
        Dialog.open({
          title: '上传banner图片',
          component: ImgUpload,
          data: {
            id: row.id,
            src: row.picture,
            width: '400px',
            from: 1
          },
          close: () => {
            this.getPage()
          }
        })
      }
    },

    updateState(idx, row, state) {
      this.pageDataList[idx]['updateLoading'] = true;
      let param = {};
      param['id'] = row.id;
      param['state'] = state;
      postFormData(updateVipBannerState, param).then((data)=>{
        let {code, msg} = data;
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'success'
          })
          this.getPage()
        }else {
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.pageDataList[idx]['updateLoading'] = false;
      }).catch(()=> {
        this.pageDataList[idx]['updateLoading'] = false;
      })
    }


  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    this.getPage();
  }
}
</script>

<style scoped>

</style>
